import { ModuleContent } from '../contract';

/**
 * Content for the Video module.
 * Mirrors legacy PascalCase fields from the AngularJS container video module.
 */
export type VideoModuleContent = {
	videoUrl: string;
	videoThumbnailUrl?: string;
	videoId?: number;
	header?: string;
	descriptionHeader?: string;
	description?: string;
	showInPopup?: boolean;
};

export function isVideoModuleContent(content: ModuleContent): content is VideoModuleContent {
	return typeof (content as VideoModuleContent).videoUrl === 'string';
}

/**
 * Returns indexable text from video header/description fields.
 */
export function getVideoModuleIndexableText(content: ModuleContent): string {
	if (!isVideoModuleContent(content)) return '';
	return [content.header, content.descriptionHeader, content.description].filter(Boolean).join(' ').trim();
}
